import {queryClient} from '@common/http/query-client';
import {listNotificationsOptions} from '@common/notifications/notifications-queries';
import {authGuard} from '../auth/guards/auth-route';
import {replace, RouteObject} from 'react-router';

export const notificationRoutes: RouteObject[] = [
  {
    path: '/notifications',
    loader: async () => {
      const redirect = authGuard();
      if (redirect) return redirect;

      await queryClient.ensureQueryData(
        listNotificationsOptions({perPage: 30}),
      );
    },
    lazy: () => import('@common/notifications/notifications-page'),
  },
  {
    path: '/notifications/settings',
    loader: async () => {
      const redirect = authGuard();
      if (redirect) return redirect;
      return replace('/account-settings/notifications');
    },
  },
];

